import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import AgentDashboard from './pages/AgentDashboard';
import AllRetailersPage from './pages/AllRetailersPage';
import AllLoansPage from './pages/AllLoansPage';
import RetailerRegistration from './pages/RetailerRegistration';
import LoanSubmission from './pages/LoanSubmission';
import CollectionRecording from './pages/CollectionRecording';
import CollectionHistory from './pages/CollectionHistory';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <AgentDashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/register-retailer"
            element={
              <PrivateRoute>
                <Layout>
                  <RetailerRegistration />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/submit-loan"
            element={
              <PrivateRoute>
                <Layout>
                  <LoanSubmission />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/record-collection"
            element={
              <PrivateRoute>
                <Layout>
                  <CollectionRecording />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/collection-history"
            element={
              <PrivateRoute>
                <Layout>
                  <CollectionHistory />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/retailers"
            element={
              <PrivateRoute>
                <Layout>
                  <AllRetailersPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/my-loans"
            element={
              <PrivateRoute>
                <Layout>
                  <AllLoansPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          <Route
            path="*"
            element={<Navigate to="/dashboard" replace />}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
